import { component, OnDestroy } from '@smoovy/component';
import { listenCompose, listenEl, Unlisten } from '@smoovy/event';

import svcs from '../services';
import { isDesktop, isMobile } from '../utils';

import { CursorEvent } from './cursor';

@component({
  selector: '[data-cursor-text]',
  condition: () => isDesktop()
})
export class CursorText implements OnDestroy {
  public static id = 0;
  private id: number;
  private text: string;
  protected unlisten?: Unlisten;

  constructor(
    protected element: HTMLElement,
    dataset = 'cursorText'
  ) {
    this.text = this.element.dataset[dataset]!;
    this.id = ++CursorText.id;

    this.init();
  }

  protected async init() {
    if (isDesktop()) {
      const cursor = await svcs.cursor.service;

      this.unlisten = listenCompose(
        listenEl(this.element, 'mouseenter', () => {
          cursor.emit(CursorEvent.UPDATE_TEXT, { id: this.id, text: this.text });
        }),
        listenEl(this.element, 'mouseleave', () => {
          cursor.emit(CursorEvent.UPDATE_TEXT, { id: this.id, text: '' });
        })
      );
    }
  }

  public onDestroy() {
    if (this.unlisten) {
      this.unlisten();
      delete this.unlisten;
    }
  }
}